module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-5.c34c9b45.png";